import { parseCookies } from '@cian/utils';

import { FOREVER_REGION_ID_COOKIE_KEY, SESSION_REGION_ID_COOKIE_KEY } from '../../../../constants/geoSwitcher';

export function getRegionIdFromCookie(): number | null {
  const cookies = parseCookies(document.cookie);
  const sessionRegionId = parseInt(cookies[SESSION_REGION_ID_COOKIE_KEY], 10);
  const foreverRegionId = parseInt(cookies[FOREVER_REGION_ID_COOKIE_KEY], 10);
  const regionId = sessionRegionId || foreverRegionId;

  if (!Number.isFinite(regionId)) {
    return null;
  }

  return Math.abs(regionId);
}
